import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import helper from '@/utils/helper'

function showError(error) {
  if (error.code === 401) {
    // to re-login
    store.dispatch('user/Logout')
    Message({
      message: error.msg,
      type: 'error',
      duration: 4 * 1000
    })
  } else {
    Message({
      message: error.msg || error.message || '服务异常',
      type: 'warning',
      duration: 3 * 1000
    })
  }
}

function Factory({ baseURL, code, msg, callFail }) {
  const $http = axios.create({
    baseURL,
    timeout: 60 * 1000
  })
  $http.interceptors.request.use(
    config => {
      config.startTime = new Date().getTime()

      if (baseURL === '/api') {
        if (config.method === 'get') {
          config.params = helper.thqs(config.params || {}, false)
        }
        if (config.method === 'post') {
          config.data = helper.thqs(config.data || {}, true)
        }
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      }

      config.headers.Authorization = getToken()

      /* 记录请求相关信息，为给debub展示 */
      config.requestConfig = {
        url: config.baseURL + config.url,
        method: config.method,
        data: config.data,
        headers: config.headers,
        params: config.params
      }

      return {
        ...config,
        validateStatus: status => {
          // 状态码在大于或等于 500 时才会 reject
          return status < 500
        }
      }
    },
    error => {
      showError(error)
      return Promise.reject(error)
    }
  )

  $http.interceptors.response.use(
    response => {
      response.config.endTime = new Date().getTime()

      const { url } = response.config

      if (url === '/docs-manage/download' && response.status === 200) {
        return response.data
      }

      const { code, state, msg } = response.data

      if ([200, 204, 201, 202].includes(+code || +state)) {
        // 在开发环境打印接口请求时间
        if (process.env.NODE_ENV === 'development') {
          console.info(response.config.url, '请求时间', response.config.endTime - response.config.startTime + 'ms')
        }
        if (+code === 202) {
          Message({
            message: msg || '服务异常',
            type: 'error',
            duration: 3 * 1000
          })
        }
        return response.data
      }
      if (code === 401) {
        // to re-login
        showError({ code, msg: '登录过期，请重新登录' })
        return
      }
      /* debug */
      console.error('请求报错提示： ', {
        ...response.config.requestConfig,
        status: response.status,
        code,
        statusText: response.statusText,
        responseData: response.data
      })
      /* debug */
      Message({
        message: response.data.msg || response.data.message || '服务异常',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(response.data)
    },
    error => {
      const { config, code } = error
      /* debug */
      console.error('请求报错提示： ', {
        ...config.requestConfig,
        code,
        message: error.message
      })
      /* debug */
      showError(error)
      return Promise.reject(error)
    }
  )
  return $http
}

export default Factory
